const values = [
  {
    title: "Technical Excellence",
    description:
      "Every line of code reflects a commitment to precision, clarity, and engineering rigor. We hold our work to the highest professional standards.",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20geometric%20crystalline%20structure%20in%20warm%20rose%20gold%20tones%20on%20soft%20pink%20gradient%20background%20minimalist%20three%20dimensional%20composition%20elegant%20faceted%20forms%20suggesting%20precision%20and%20technical%20excellence%20no%20people%20abstract%20art&width=600&height=800&seq=value-excel-mq-01&orientation=portrait",
    bgClass: "bg-[#f3e8e4]",
  },
  {
    title: "Continuous Innovation",
    description:
      "We actively explore emerging technologies and methodologies, integrating new insights into our workflows to stay ahead of the evolving engineering landscape.",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20flowing%20organic%20geometric%20forms%20in%20deep%20sage%20green%20and%20mint%20tones%20suggesting%20growth%20and%20evolution%20layered%20translucent%20shapes%20on%20soft%20green%20background%20modern%20minimalist%20composition%20no%20people%20abstract%20art&width=600&height=800&seq=value-innov-mq-02&orientation=portrait",
    bgClass: "bg-[#dce8df]",
  },
  {
    title: "User-Centered Focus",
    description:
      "Great engineering serves people. We design every system with the end user in mind, prioritizing usability, accessibility, and intuitive interaction.",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20concentric%20geometric%20circles%20and%20rounded%20forms%20in%20soft%20warm%20gray%20and%20silver%20tones%20suggesting%20harmony%20and%20balance%20clean%20minimal%20composition%20on%20light%20gray%20background%20subtle%20depth%20and%20layering%20no%20people%20abstract%20art&width=600&height=800&seq=value-user-mq-03&orientation=portrait",
    bgClass: "bg-[#e4e4e1]",
  },
  {
    title: "Long-Term Quality",
    description:
      "We build for durability. Our systems are designed to remain maintainable, adaptable, and performant well into the future — not just at launch.",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stacked%20geometric%20blocks%20and%20structural%20forms%20in%20warm%20amber%20and%20golden%20beige%20tones%20suggesting%20stability%20and%20durability%20solid%20grounded%20composition%20on%20warm%20cream%20background%20modern%20minimalist%20aesthetic%20no%20people%20abstract%20art&width=600&height=800&seq=value-quality-mq-04&orientation=portrait",
    bgClass: "bg-[#efe4d4]",
  },
];

export default function ValuesSection() {
  return (
    <section className="relative bg-background-100 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <p className="font-heading text-sm md:text-base italic text-foreground-500 mb-3">
          What drives us
        </p>
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-foreground-900 leading-tight mb-4">
          Core Values
        </h2>
        <p className="font-heading text-2xl md:text-4xl italic font-normal text-foreground-600 mb-14 md:mb-20">
          that shape every project
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {values.map((value, index) => (
            <div
              key={index}
              className="rounded-2xl overflow-hidden flex flex-col"
            >
              <div className={`${value.bgClass} p-6 md:p-8 flex items-center justify-center`}>
                <div className="w-full aspect-[3/4] relative rounded-xl overflow-hidden">
                  <img
                    src={value.image}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="bg-background-50 px-5 md:px-6 py-5 md:py-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                  {value.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}